/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AnswerFacultyCourseGapsBody } from '../models';
// @ts-ignore
import type { CreateFacultyCourseBody } from '../models';
// @ts-ignore
import type { DropFacultyCourseSubtopicBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { FacultyCourseNameBody } from '../models';
// @ts-ignore
import type { GetAllFacultyCoursesResponse } from '../models';
// @ts-ignore
import type { GetFacultyCourseCardsResponse } from '../models';
// @ts-ignore
import type { GetFacultyCourseResponse } from '../models';
// @ts-ignore
import type { MoveFacultyCourseModuleBody } from '../models';
// @ts-ignore
import type { PublishFacultyCourseBody } from '../models';
// @ts-ignore
import type { SendFacultyCourseChatBody } from '../models';
// @ts-ignore
import type { StartFacultyCourseBuildBody } from '../models';
// @ts-ignore
import type { StartFacultyCourseOutlineBody } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateFacultyCourseCardsBody } from '../models';
// @ts-ignore
import type { UpdateFacultyCoursePlanBody } from '../models';
// @ts-ignore
import type { UploadLessonImageResponse } from '../models';
// @ts-ignore
import type { WriteFacultyCourseLessonsBody } from '../models';
/**
 * FacultyCourseApiApi - axios parameter creator
 */
export const FacultyCourseApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} courseId 
         * @param {FacultyCourseNameBody} facultyCourseNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiAddModule: async (courseId: string, facultyCourseNameBody: FacultyCourseNameBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiAddModule', 'courseId', courseId)
            // verify required parameter 'facultyCourseNameBody' is not null or undefined
            assertParamExists('facultyCourseApiAddModule', 'facultyCourseNameBody', facultyCourseNameBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/modules`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facultyCourseNameBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} topicId 
         * @param {FacultyCourseNameBody} facultyCourseNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiAddSubtopic: async (courseId: string, topicId: string, facultyCourseNameBody: FacultyCourseNameBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiAddSubtopic', 'courseId', courseId)
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('facultyCourseApiAddSubtopic', 'topicId', topicId)
            // verify required parameter 'facultyCourseNameBody' is not null or undefined
            assertParamExists('facultyCourseApiAddSubtopic', 'facultyCourseNameBody', facultyCourseNameBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/modules/{topic_id}/subtopics`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{topic_id}', encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facultyCourseNameBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {AnswerFacultyCourseGapsBody} answerFacultyCourseGapsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiAnswerGaps: async (courseId: string, answerFacultyCourseGapsBody: AnswerFacultyCourseGapsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiAnswerGaps', 'courseId', courseId)
            // verify required parameter 'answerFacultyCourseGapsBody' is not null or undefined
            assertParamExists('facultyCourseApiAnswerGaps', 'answerFacultyCourseGapsBody', answerFacultyCourseGapsBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/gaps`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(answerFacultyCourseGapsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateFacultyCourseBody} createFacultyCourseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiCreateCourse: async (createFacultyCourseBody: CreateFacultyCourseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFacultyCourseBody' is not null or undefined
            assertParamExists('facultyCourseApiCreateCourse', 'createFacultyCourseBody', createFacultyCourseBody)
            const localVarPath = `/api/v1/faculty/courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFacultyCourseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiDeleteCourse: async (courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiDeleteCourse', 'courseId', courseId)
            const localVarPath = `/api/v1/faculty/courses/{course_id}`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiDeleteModule: async (courseId: string, skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiDeleteModule', 'courseId', courseId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('facultyCourseApiDeleteModule', 'skillId', skillId)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/modules/{skill_id}`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiDeleteSubtopic: async (courseId: string, skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiDeleteSubtopic', 'courseId', courseId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('facultyCourseApiDeleteSubtopic', 'skillId', skillId)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/subtopics/{skill_id}`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} labelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiDismissFailedLesson: async (courseId: string, labelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiDismissFailedLesson', 'courseId', courseId)
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('facultyCourseApiDismissFailedLesson', 'labelId', labelId)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/lessons/{label_id}/failed`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{label_id}', encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiGetCourse: async (courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiGetCourse', 'courseId', courseId)
            const localVarPath = `/api/v1/faculty/courses/{course_id}`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} labelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiGetLessonCards: async (courseId: string, labelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiGetLessonCards', 'courseId', courseId)
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('facultyCourseApiGetLessonCards', 'labelId', labelId)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/lessons/{label_id}/cards`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{label_id}', encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [classId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiListCourses: async (classId?: string, page?: number, pageSize?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/faculty/courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (classId !== undefined) {
                localVarQueryParameter['class_id'] = classId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} topicId 
         * @param {MoveFacultyCourseModuleBody} moveFacultyCourseModuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiMoveModule: async (courseId: string, topicId: string, moveFacultyCourseModuleBody: MoveFacultyCourseModuleBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiMoveModule', 'courseId', courseId)
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('facultyCourseApiMoveModule', 'topicId', topicId)
            // verify required parameter 'moveFacultyCourseModuleBody' is not null or undefined
            assertParamExists('facultyCourseApiMoveModule', 'moveFacultyCourseModuleBody', moveFacultyCourseModuleBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/modules/{topic_id}/move`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{topic_id}', encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveFacultyCourseModuleBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {PublishFacultyCourseBody} publishFacultyCourseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiPublishCourse: async (courseId: string, publishFacultyCourseBody: PublishFacultyCourseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiPublishCourse', 'courseId', courseId)
            // verify required parameter 'publishFacultyCourseBody' is not null or undefined
            assertParamExists('facultyCourseApiPublishCourse', 'publishFacultyCourseBody', publishFacultyCourseBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/publish`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishFacultyCourseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} skillId 
         * @param {FacultyCourseNameBody} facultyCourseNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiRenameNode: async (courseId: string, skillId: string, facultyCourseNameBody: FacultyCourseNameBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiRenameNode', 'courseId', courseId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('facultyCourseApiRenameNode', 'skillId', skillId)
            // verify required parameter 'facultyCourseNameBody' is not null or undefined
            assertParamExists('facultyCourseApiRenameNode', 'facultyCourseNameBody', facultyCourseNameBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/nodes/{skill_id}`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facultyCourseNameBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} labelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiRetryLesson: async (courseId: string, labelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiRetryLesson', 'courseId', courseId)
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('facultyCourseApiRetryLesson', 'labelId', labelId)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/lessons/{label_id}/retry`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{label_id}', encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {SendFacultyCourseChatBody} sendFacultyCourseChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiSendChat: async (courseId: string, sendFacultyCourseChatBody: SendFacultyCourseChatBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiSendChat', 'courseId', courseId)
            // verify required parameter 'sendFacultyCourseChatBody' is not null or undefined
            assertParamExists('facultyCourseApiSendChat', 'sendFacultyCourseChatBody', sendFacultyCourseChatBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/chat`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendFacultyCourseChatBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hide a module from the course (`dropped`), or show it again.
         * @param {string} courseId 
         * @param {string} skillId 
         * @param {DropFacultyCourseSubtopicBody} dropFacultyCourseSubtopicBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiSetModuleHidden: async (courseId: string, skillId: string, dropFacultyCourseSubtopicBody: DropFacultyCourseSubtopicBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiSetModuleHidden', 'courseId', courseId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('facultyCourseApiSetModuleHidden', 'skillId', skillId)
            // verify required parameter 'dropFacultyCourseSubtopicBody' is not null or undefined
            assertParamExists('facultyCourseApiSetModuleHidden', 'dropFacultyCourseSubtopicBody', dropFacultyCourseSubtopicBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/modules/{skill_id}/dropped`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dropFacultyCourseSubtopicBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} skillId 
         * @param {DropFacultyCourseSubtopicBody} dropFacultyCourseSubtopicBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiSetSubtopicDropped: async (courseId: string, skillId: string, dropFacultyCourseSubtopicBody: DropFacultyCourseSubtopicBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiSetSubtopicDropped', 'courseId', courseId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('facultyCourseApiSetSubtopicDropped', 'skillId', skillId)
            // verify required parameter 'dropFacultyCourseSubtopicBody' is not null or undefined
            assertParamExists('facultyCourseApiSetSubtopicDropped', 'dropFacultyCourseSubtopicBody', dropFacultyCourseSubtopicBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/subtopics/{skill_id}/dropped`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dropFacultyCourseSubtopicBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {StartFacultyCourseBuildBody} startFacultyCourseBuildBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiStartBuild: async (courseId: string, startFacultyCourseBuildBody: StartFacultyCourseBuildBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiStartBuild', 'courseId', courseId)
            // verify required parameter 'startFacultyCourseBuildBody' is not null or undefined
            assertParamExists('facultyCourseApiStartBuild', 'startFacultyCourseBuildBody', startFacultyCourseBuildBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/build`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startFacultyCourseBuildBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {StartFacultyCourseOutlineBody} startFacultyCourseOutlineBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiStartOutline: async (courseId: string, startFacultyCourseOutlineBody: StartFacultyCourseOutlineBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiStartOutline', 'courseId', courseId)
            // verify required parameter 'startFacultyCourseOutlineBody' is not null or undefined
            assertParamExists('facultyCourseApiStartOutline', 'startFacultyCourseOutlineBody', startFacultyCourseOutlineBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/outline`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startFacultyCourseOutlineBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} labelId 
         * @param {UpdateFacultyCourseCardsBody} updateFacultyCourseCardsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiUpdateLessonCards: async (courseId: string, labelId: string, updateFacultyCourseCardsBody: UpdateFacultyCourseCardsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiUpdateLessonCards', 'courseId', courseId)
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('facultyCourseApiUpdateLessonCards', 'labelId', labelId)
            // verify required parameter 'updateFacultyCourseCardsBody' is not null or undefined
            assertParamExists('facultyCourseApiUpdateLessonCards', 'updateFacultyCourseCardsBody', updateFacultyCourseCardsBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/lessons/{label_id}/cards`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{label_id}', encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFacultyCourseCardsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {UpdateFacultyCoursePlanBody} updateFacultyCoursePlanBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiUpdatePlan: async (courseId: string, updateFacultyCoursePlanBody: UpdateFacultyCoursePlanBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiUpdatePlan', 'courseId', courseId)
            // verify required parameter 'updateFacultyCoursePlanBody' is not null or undefined
            assertParamExists('facultyCourseApiUpdatePlan', 'updateFacultyCoursePlanBody', updateFacultyCoursePlanBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/plan`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFacultyCoursePlanBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} labelId 
         * @param {File} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiUploadLessonImage: async (courseId: string, labelId: string, image: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiUploadLessonImage', 'courseId', courseId)
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('facultyCourseApiUploadLessonImage', 'labelId', labelId)
            // verify required parameter 'image' is not null or undefined
            assertParamExists('facultyCourseApiUploadLessonImage', 'image', image)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/lessons/{label_id}/images`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{label_id}', encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {WriteFacultyCourseLessonsBody} writeFacultyCourseLessonsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiWriteLessons: async (courseId: string, writeFacultyCourseLessonsBody: WriteFacultyCourseLessonsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('facultyCourseApiWriteLessons', 'courseId', courseId)
            // verify required parameter 'writeFacultyCourseLessonsBody' is not null or undefined
            assertParamExists('facultyCourseApiWriteLessons', 'writeFacultyCourseLessonsBody', writeFacultyCourseLessonsBody)
            const localVarPath = `/api/v1/faculty/courses/{course_id}/lessons/write`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeFacultyCourseLessonsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacultyCourseApiApi - functional programming interface
 */
export const FacultyCourseApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacultyCourseApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} courseId 
         * @param {FacultyCourseNameBody} facultyCourseNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiAddModule(courseId: string, facultyCourseNameBody: FacultyCourseNameBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiAddModule(courseId, facultyCourseNameBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiAddModule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} topicId 
         * @param {FacultyCourseNameBody} facultyCourseNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiAddSubtopic(courseId: string, topicId: string, facultyCourseNameBody: FacultyCourseNameBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiAddSubtopic(courseId, topicId, facultyCourseNameBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiAddSubtopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {AnswerFacultyCourseGapsBody} answerFacultyCourseGapsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiAnswerGaps(courseId: string, answerFacultyCourseGapsBody: AnswerFacultyCourseGapsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiAnswerGaps(courseId, answerFacultyCourseGapsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiAnswerGaps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateFacultyCourseBody} createFacultyCourseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiCreateCourse(createFacultyCourseBody: CreateFacultyCourseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiCreateCourse(createFacultyCourseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiCreateCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiDeleteCourse(courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiDeleteCourse(courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiDeleteCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiDeleteModule(courseId: string, skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiDeleteModule(courseId, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiDeleteModule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiDeleteSubtopic(courseId: string, skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiDeleteSubtopic(courseId, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiDeleteSubtopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} labelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiDismissFailedLesson(courseId: string, labelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiDismissFailedLesson(courseId, labelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiDismissFailedLesson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiGetCourse(courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiGetCourse(courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiGetCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} labelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiGetLessonCards(courseId: string, labelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseCardsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiGetLessonCards(courseId, labelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiGetLessonCards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [classId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiListCourses(classId?: string, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllFacultyCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiListCourses(classId, page, pageSize, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiListCourses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} topicId 
         * @param {MoveFacultyCourseModuleBody} moveFacultyCourseModuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiMoveModule(courseId: string, topicId: string, moveFacultyCourseModuleBody: MoveFacultyCourseModuleBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiMoveModule(courseId, topicId, moveFacultyCourseModuleBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiMoveModule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {PublishFacultyCourseBody} publishFacultyCourseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiPublishCourse(courseId: string, publishFacultyCourseBody: PublishFacultyCourseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiPublishCourse(courseId, publishFacultyCourseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiPublishCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} skillId 
         * @param {FacultyCourseNameBody} facultyCourseNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiRenameNode(courseId: string, skillId: string, facultyCourseNameBody: FacultyCourseNameBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiRenameNode(courseId, skillId, facultyCourseNameBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiRenameNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} labelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiRetryLesson(courseId: string, labelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiRetryLesson(courseId, labelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiRetryLesson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {SendFacultyCourseChatBody} sendFacultyCourseChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiSendChat(courseId: string, sendFacultyCourseChatBody: SendFacultyCourseChatBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiSendChat(courseId, sendFacultyCourseChatBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiSendChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Hide a module from the course (`dropped`), or show it again.
         * @param {string} courseId 
         * @param {string} skillId 
         * @param {DropFacultyCourseSubtopicBody} dropFacultyCourseSubtopicBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiSetModuleHidden(courseId: string, skillId: string, dropFacultyCourseSubtopicBody: DropFacultyCourseSubtopicBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiSetModuleHidden(courseId, skillId, dropFacultyCourseSubtopicBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiSetModuleHidden']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} skillId 
         * @param {DropFacultyCourseSubtopicBody} dropFacultyCourseSubtopicBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiSetSubtopicDropped(courseId: string, skillId: string, dropFacultyCourseSubtopicBody: DropFacultyCourseSubtopicBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiSetSubtopicDropped(courseId, skillId, dropFacultyCourseSubtopicBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiSetSubtopicDropped']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {StartFacultyCourseBuildBody} startFacultyCourseBuildBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiStartBuild(courseId: string, startFacultyCourseBuildBody: StartFacultyCourseBuildBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiStartBuild(courseId, startFacultyCourseBuildBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiStartBuild']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {StartFacultyCourseOutlineBody} startFacultyCourseOutlineBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiStartOutline(courseId: string, startFacultyCourseOutlineBody: StartFacultyCourseOutlineBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiStartOutline(courseId, startFacultyCourseOutlineBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiStartOutline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} labelId 
         * @param {UpdateFacultyCourseCardsBody} updateFacultyCourseCardsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiUpdateLessonCards(courseId: string, labelId: string, updateFacultyCourseCardsBody: UpdateFacultyCourseCardsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseCardsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiUpdateLessonCards(courseId, labelId, updateFacultyCourseCardsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiUpdateLessonCards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {UpdateFacultyCoursePlanBody} updateFacultyCoursePlanBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiUpdatePlan(courseId: string, updateFacultyCoursePlanBody: UpdateFacultyCoursePlanBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiUpdatePlan(courseId, updateFacultyCoursePlanBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiUpdatePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} labelId 
         * @param {File} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiUploadLessonImage(courseId: string, labelId: string, image: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadLessonImageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiUploadLessonImage(courseId, labelId, image, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiUploadLessonImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {WriteFacultyCourseLessonsBody} writeFacultyCourseLessonsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyCourseApiWriteLessons(courseId: string, writeFacultyCourseLessonsBody: WriteFacultyCourseLessonsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyCourseApiWriteLessons(courseId, writeFacultyCourseLessonsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyCourseApiApi.facultyCourseApiWriteLessons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FacultyCourseApiApi - factory interface
 */
export const FacultyCourseApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacultyCourseApiApiFp(configuration)
    return {
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiAddModuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiAddModule(requestParameters: FacultyCourseApiApiFacultyCourseApiAddModuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiAddModule(requestParameters.courseId, requestParameters.facultyCourseNameBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiAddSubtopicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiAddSubtopic(requestParameters: FacultyCourseApiApiFacultyCourseApiAddSubtopicRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiAddSubtopic(requestParameters.courseId, requestParameters.topicId, requestParameters.facultyCourseNameBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiAnswerGapsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiAnswerGaps(requestParameters: FacultyCourseApiApiFacultyCourseApiAnswerGapsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiAnswerGaps(requestParameters.courseId, requestParameters.answerFacultyCourseGapsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiCreateCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiCreateCourse(requestParameters: FacultyCourseApiApiFacultyCourseApiCreateCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiCreateCourse(requestParameters.createFacultyCourseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiDeleteCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiDeleteCourse(requestParameters: FacultyCourseApiApiFacultyCourseApiDeleteCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.facultyCourseApiDeleteCourse(requestParameters.courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiDeleteModuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiDeleteModule(requestParameters: FacultyCourseApiApiFacultyCourseApiDeleteModuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiDeleteModule(requestParameters.courseId, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiDeleteSubtopicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiDeleteSubtopic(requestParameters: FacultyCourseApiApiFacultyCourseApiDeleteSubtopicRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiDeleteSubtopic(requestParameters.courseId, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiDismissFailedLessonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiDismissFailedLesson(requestParameters: FacultyCourseApiApiFacultyCourseApiDismissFailedLessonRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiDismissFailedLesson(requestParameters.courseId, requestParameters.labelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiGetCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiGetCourse(requestParameters: FacultyCourseApiApiFacultyCourseApiGetCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiGetCourse(requestParameters.courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiGetLessonCardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiGetLessonCards(requestParameters: FacultyCourseApiApiFacultyCourseApiGetLessonCardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseCardsResponse> {
            return localVarFp.facultyCourseApiGetLessonCards(requestParameters.courseId, requestParameters.labelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiListCoursesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiListCourses(requestParameters: FacultyCourseApiApiFacultyCourseApiListCoursesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllFacultyCoursesResponse> {
            return localVarFp.facultyCourseApiListCourses(requestParameters.classId, requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiMoveModuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiMoveModule(requestParameters: FacultyCourseApiApiFacultyCourseApiMoveModuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiMoveModule(requestParameters.courseId, requestParameters.topicId, requestParameters.moveFacultyCourseModuleBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiPublishCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiPublishCourse(requestParameters: FacultyCourseApiApiFacultyCourseApiPublishCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiPublishCourse(requestParameters.courseId, requestParameters.publishFacultyCourseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiRenameNodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiRenameNode(requestParameters: FacultyCourseApiApiFacultyCourseApiRenameNodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiRenameNode(requestParameters.courseId, requestParameters.skillId, requestParameters.facultyCourseNameBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiRetryLessonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiRetryLesson(requestParameters: FacultyCourseApiApiFacultyCourseApiRetryLessonRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiRetryLesson(requestParameters.courseId, requestParameters.labelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiSendChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiSendChat(requestParameters: FacultyCourseApiApiFacultyCourseApiSendChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiSendChat(requestParameters.courseId, requestParameters.sendFacultyCourseChatBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hide a module from the course (`dropped`), or show it again.
         * @param {FacultyCourseApiApiFacultyCourseApiSetModuleHiddenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiSetModuleHidden(requestParameters: FacultyCourseApiApiFacultyCourseApiSetModuleHiddenRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiSetModuleHidden(requestParameters.courseId, requestParameters.skillId, requestParameters.dropFacultyCourseSubtopicBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiSetSubtopicDroppedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiSetSubtopicDropped(requestParameters: FacultyCourseApiApiFacultyCourseApiSetSubtopicDroppedRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiSetSubtopicDropped(requestParameters.courseId, requestParameters.skillId, requestParameters.dropFacultyCourseSubtopicBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiStartBuildRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiStartBuild(requestParameters: FacultyCourseApiApiFacultyCourseApiStartBuildRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiStartBuild(requestParameters.courseId, requestParameters.startFacultyCourseBuildBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiStartOutlineRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiStartOutline(requestParameters: FacultyCourseApiApiFacultyCourseApiStartOutlineRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiStartOutline(requestParameters.courseId, requestParameters.startFacultyCourseOutlineBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiUpdateLessonCardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiUpdateLessonCards(requestParameters: FacultyCourseApiApiFacultyCourseApiUpdateLessonCardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseCardsResponse> {
            return localVarFp.facultyCourseApiUpdateLessonCards(requestParameters.courseId, requestParameters.labelId, requestParameters.updateFacultyCourseCardsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiUpdatePlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiUpdatePlan(requestParameters: FacultyCourseApiApiFacultyCourseApiUpdatePlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiUpdatePlan(requestParameters.courseId, requestParameters.updateFacultyCoursePlanBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiUploadLessonImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiUploadLessonImage(requestParameters: FacultyCourseApiApiFacultyCourseApiUploadLessonImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadLessonImageResponse> {
            return localVarFp.facultyCourseApiUploadLessonImage(requestParameters.courseId, requestParameters.labelId, requestParameters.image, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyCourseApiApiFacultyCourseApiWriteLessonsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyCourseApiWriteLessons(requestParameters: FacultyCourseApiApiFacultyCourseApiWriteLessonsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyCourseResponse> {
            return localVarFp.facultyCourseApiWriteLessons(requestParameters.courseId, requestParameters.writeFacultyCourseLessonsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for facultyCourseApiAddModule operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiAddModuleRequest {
    readonly courseId: string

    readonly facultyCourseNameBody: FacultyCourseNameBody
}

/**
 * Request parameters for facultyCourseApiAddSubtopic operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiAddSubtopicRequest {
    readonly courseId: string

    readonly topicId: string

    readonly facultyCourseNameBody: FacultyCourseNameBody
}

/**
 * Request parameters for facultyCourseApiAnswerGaps operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiAnswerGapsRequest {
    readonly courseId: string

    readonly answerFacultyCourseGapsBody: AnswerFacultyCourseGapsBody
}

/**
 * Request parameters for facultyCourseApiCreateCourse operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiCreateCourseRequest {
    readonly createFacultyCourseBody: CreateFacultyCourseBody
}

/**
 * Request parameters for facultyCourseApiDeleteCourse operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiDeleteCourseRequest {
    readonly courseId: string
}

/**
 * Request parameters for facultyCourseApiDeleteModule operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiDeleteModuleRequest {
    readonly courseId: string

    readonly skillId: string
}

/**
 * Request parameters for facultyCourseApiDeleteSubtopic operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiDeleteSubtopicRequest {
    readonly courseId: string

    readonly skillId: string
}

/**
 * Request parameters for facultyCourseApiDismissFailedLesson operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiDismissFailedLessonRequest {
    readonly courseId: string

    readonly labelId: string
}

/**
 * Request parameters for facultyCourseApiGetCourse operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiGetCourseRequest {
    readonly courseId: string
}

/**
 * Request parameters for facultyCourseApiGetLessonCards operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiGetLessonCardsRequest {
    readonly courseId: string

    readonly labelId: string
}

/**
 * Request parameters for facultyCourseApiListCourses operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiListCoursesRequest {
    readonly classId?: string

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string
}

/**
 * Request parameters for facultyCourseApiMoveModule operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiMoveModuleRequest {
    readonly courseId: string

    readonly topicId: string

    readonly moveFacultyCourseModuleBody: MoveFacultyCourseModuleBody
}

/**
 * Request parameters for facultyCourseApiPublishCourse operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiPublishCourseRequest {
    readonly courseId: string

    readonly publishFacultyCourseBody: PublishFacultyCourseBody
}

/**
 * Request parameters for facultyCourseApiRenameNode operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiRenameNodeRequest {
    readonly courseId: string

    readonly skillId: string

    readonly facultyCourseNameBody: FacultyCourseNameBody
}

/**
 * Request parameters for facultyCourseApiRetryLesson operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiRetryLessonRequest {
    readonly courseId: string

    readonly labelId: string
}

/**
 * Request parameters for facultyCourseApiSendChat operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiSendChatRequest {
    readonly courseId: string

    readonly sendFacultyCourseChatBody: SendFacultyCourseChatBody
}

/**
 * Request parameters for facultyCourseApiSetModuleHidden operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiSetModuleHiddenRequest {
    readonly courseId: string

    readonly skillId: string

    readonly dropFacultyCourseSubtopicBody: DropFacultyCourseSubtopicBody
}

/**
 * Request parameters for facultyCourseApiSetSubtopicDropped operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiSetSubtopicDroppedRequest {
    readonly courseId: string

    readonly skillId: string

    readonly dropFacultyCourseSubtopicBody: DropFacultyCourseSubtopicBody
}

/**
 * Request parameters for facultyCourseApiStartBuild operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiStartBuildRequest {
    readonly courseId: string

    readonly startFacultyCourseBuildBody: StartFacultyCourseBuildBody
}

/**
 * Request parameters for facultyCourseApiStartOutline operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiStartOutlineRequest {
    readonly courseId: string

    readonly startFacultyCourseOutlineBody: StartFacultyCourseOutlineBody
}

/**
 * Request parameters for facultyCourseApiUpdateLessonCards operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiUpdateLessonCardsRequest {
    readonly courseId: string

    readonly labelId: string

    readonly updateFacultyCourseCardsBody: UpdateFacultyCourseCardsBody
}

/**
 * Request parameters for facultyCourseApiUpdatePlan operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiUpdatePlanRequest {
    readonly courseId: string

    readonly updateFacultyCoursePlanBody: UpdateFacultyCoursePlanBody
}

/**
 * Request parameters for facultyCourseApiUploadLessonImage operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiUploadLessonImageRequest {
    readonly courseId: string

    readonly labelId: string

    readonly image: File
}

/**
 * Request parameters for facultyCourseApiWriteLessons operation in FacultyCourseApiApi.
 */
export interface FacultyCourseApiApiFacultyCourseApiWriteLessonsRequest {
    readonly courseId: string

    readonly writeFacultyCourseLessonsBody: WriteFacultyCourseLessonsBody
}

/**
 * FacultyCourseApiApi - object-oriented interface
 */
export class FacultyCourseApiApi extends BaseAPI {
    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiAddModuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiAddModule(requestParameters: FacultyCourseApiApiFacultyCourseApiAddModuleRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiAddModule(requestParameters.courseId, requestParameters.facultyCourseNameBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiAddSubtopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiAddSubtopic(requestParameters: FacultyCourseApiApiFacultyCourseApiAddSubtopicRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiAddSubtopic(requestParameters.courseId, requestParameters.topicId, requestParameters.facultyCourseNameBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiAnswerGapsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiAnswerGaps(requestParameters: FacultyCourseApiApiFacultyCourseApiAnswerGapsRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiAnswerGaps(requestParameters.courseId, requestParameters.answerFacultyCourseGapsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiCreateCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiCreateCourse(requestParameters: FacultyCourseApiApiFacultyCourseApiCreateCourseRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiCreateCourse(requestParameters.createFacultyCourseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiDeleteCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiDeleteCourse(requestParameters: FacultyCourseApiApiFacultyCourseApiDeleteCourseRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiDeleteCourse(requestParameters.courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiDeleteModuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiDeleteModule(requestParameters: FacultyCourseApiApiFacultyCourseApiDeleteModuleRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiDeleteModule(requestParameters.courseId, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiDeleteSubtopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiDeleteSubtopic(requestParameters: FacultyCourseApiApiFacultyCourseApiDeleteSubtopicRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiDeleteSubtopic(requestParameters.courseId, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiDismissFailedLessonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiDismissFailedLesson(requestParameters: FacultyCourseApiApiFacultyCourseApiDismissFailedLessonRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiDismissFailedLesson(requestParameters.courseId, requestParameters.labelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiGetCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiGetCourse(requestParameters: FacultyCourseApiApiFacultyCourseApiGetCourseRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiGetCourse(requestParameters.courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiGetLessonCardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiGetLessonCards(requestParameters: FacultyCourseApiApiFacultyCourseApiGetLessonCardsRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiGetLessonCards(requestParameters.courseId, requestParameters.labelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiListCoursesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiListCourses(requestParameters: FacultyCourseApiApiFacultyCourseApiListCoursesRequest = {}, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiListCourses(requestParameters.classId, requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiMoveModuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiMoveModule(requestParameters: FacultyCourseApiApiFacultyCourseApiMoveModuleRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiMoveModule(requestParameters.courseId, requestParameters.topicId, requestParameters.moveFacultyCourseModuleBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiPublishCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiPublishCourse(requestParameters: FacultyCourseApiApiFacultyCourseApiPublishCourseRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiPublishCourse(requestParameters.courseId, requestParameters.publishFacultyCourseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiRenameNodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiRenameNode(requestParameters: FacultyCourseApiApiFacultyCourseApiRenameNodeRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiRenameNode(requestParameters.courseId, requestParameters.skillId, requestParameters.facultyCourseNameBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiRetryLessonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiRetryLesson(requestParameters: FacultyCourseApiApiFacultyCourseApiRetryLessonRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiRetryLesson(requestParameters.courseId, requestParameters.labelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiSendChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiSendChat(requestParameters: FacultyCourseApiApiFacultyCourseApiSendChatRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiSendChat(requestParameters.courseId, requestParameters.sendFacultyCourseChatBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hide a module from the course (`dropped`), or show it again.
     * @param {FacultyCourseApiApiFacultyCourseApiSetModuleHiddenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiSetModuleHidden(requestParameters: FacultyCourseApiApiFacultyCourseApiSetModuleHiddenRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiSetModuleHidden(requestParameters.courseId, requestParameters.skillId, requestParameters.dropFacultyCourseSubtopicBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiSetSubtopicDroppedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiSetSubtopicDropped(requestParameters: FacultyCourseApiApiFacultyCourseApiSetSubtopicDroppedRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiSetSubtopicDropped(requestParameters.courseId, requestParameters.skillId, requestParameters.dropFacultyCourseSubtopicBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiStartBuildRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiStartBuild(requestParameters: FacultyCourseApiApiFacultyCourseApiStartBuildRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiStartBuild(requestParameters.courseId, requestParameters.startFacultyCourseBuildBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiStartOutlineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiStartOutline(requestParameters: FacultyCourseApiApiFacultyCourseApiStartOutlineRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiStartOutline(requestParameters.courseId, requestParameters.startFacultyCourseOutlineBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiUpdateLessonCardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiUpdateLessonCards(requestParameters: FacultyCourseApiApiFacultyCourseApiUpdateLessonCardsRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiUpdateLessonCards(requestParameters.courseId, requestParameters.labelId, requestParameters.updateFacultyCourseCardsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiUpdatePlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiUpdatePlan(requestParameters: FacultyCourseApiApiFacultyCourseApiUpdatePlanRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiUpdatePlan(requestParameters.courseId, requestParameters.updateFacultyCoursePlanBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiUploadLessonImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiUploadLessonImage(requestParameters: FacultyCourseApiApiFacultyCourseApiUploadLessonImageRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiUploadLessonImage(requestParameters.courseId, requestParameters.labelId, requestParameters.image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyCourseApiApiFacultyCourseApiWriteLessonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyCourseApiWriteLessons(requestParameters: FacultyCourseApiApiFacultyCourseApiWriteLessonsRequest, options?: RawAxiosRequestConfig) {
        return FacultyCourseApiApiFp(this.configuration).facultyCourseApiWriteLessons(requestParameters.courseId, requestParameters.writeFacultyCourseLessonsBody, options).then((request) => request(this.axios, this.basePath));
    }
}

